const revealImage = (image) => {
  if (image.dataset.smoothImageReady === 'true') {
    return
  }

  const originalOpacity = image.dataset.smoothImageOriginalOpacity || ''

  image.style.opacity = originalOpacity
  const finalOpacity = window.getComputedStyle(image).opacity || '1'
  image.style.opacity = '0'

  requestAnimationFrame(() => {
    image.dataset.smoothImageReady = 'true'

    image.animate(
      [
        { opacity: 0, filter: 'blur(4px)' },
        { opacity: finalOpacity, filter: 'blur(0)' },
      ],
      {
        duration: 260,
        easing: 'cubic-bezier(0.2, 0, 0, 1)',
        fill: 'none',
      }
    )

    if (originalOpacity) {
      image.style.opacity = originalOpacity
    } else {
      image.style.removeProperty('opacity')
    }
  })
}

const prepareImage = (image) => {
  if (!(image instanceof HTMLImageElement) || image.dataset.smoothImageTracked === 'true') {
    return
  }

  image.dataset.smoothImageTracked = 'true'
  image.dataset.smoothImageReady = 'false'
  image.dataset.smoothImageOriginalOpacity = image.style.opacity || ''
  image.style.opacity = '0'

  const revealWhenDecoded = () => {
    if (image.decode) {
      image.decode().then(() => revealImage(image)).catch(() => revealImage(image))
      return
    }

    revealImage(image)
  }

  if (image.complete && image.naturalWidth > 0) {
    revealWhenDecoded()
    return
  }

  image.addEventListener('load', revealWhenDecoded, { once: true })
  image.addEventListener('error', () => revealImage(image), { once: true })
}

const resetImage = (image) => {
  const originalOpacity = image.dataset.smoothImageOriginalOpacity || ''

  if (originalOpacity) {
    image.style.opacity = originalOpacity
  } else {
    image.style.removeProperty('opacity')
  }

  image.dataset.smoothImageTracked = 'false'
  image.dataset.smoothImageReady = 'false'
  prepareImage(image)
}

export const installSmoothImages = () => {
  if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') {
    return
  }

  document.querySelectorAll('img').forEach(prepareImage)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLImageElement) {
            prepareImage(node)
            return
          }

          if (node instanceof HTMLElement) {
            node.querySelectorAll('img').forEach(prepareImage)
          }
        })
      }

      if (
        mutation.type === 'attributes' &&
        mutation.target instanceof HTMLImageElement &&
        ['src', 'srcset'].includes(mutation.attributeName)
      ) {
        resetImage(mutation.target)
      }
    })
  })

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset'],
  })
}
